
import WDPane from './wd-pane';
import WDList from '../lists/wd-list';

export default class WDPaneList extends WDPane
{
	#list = null;
	#config = {};

	constructor(cfg)
	{
		super(cfg).classList.add('wd-pane-list');
		if (cfg) Object.assign(this.#config, cfg);
	};

	connectedCallback()
	{
		super.connectedCallback();

		/*
		this.panes.on('pane:added',() => {
			const items = this.panes.items;
			if (items.length >= 2 && items[items.length-2] == this)
			{
				setTimeout( () => {
					if (this.list.selectedItem)
					{
						this.list.selectedItem.scrollTo();
					}
					
				}, WDConfig.panes.transition);
			}
		});
		*/
	}

	/** public accessors **/
	get config() { return this.#config; };
	get model() { return this.#list.model; };
	set fetch(val) { this.#list.fetch = val; };
	get fetch() { return this.#list.fetch; };
	fetchModel() { return this.#list.fetchModel(); };
	refresh() { return this.#list.fetchModel(); };

	get list() { return this.#list; };
	set list(elem)
	{
		this.#list = elem;
		this.body.append(this.#list);

		const fwdEvents = ['model:fetch', 'model:fetched', 'items:added', 'model:set', 'sort:updated'];
		this.#list.on(fwdEvents, evt =>
		{
			this.trigger(evt.type, evt.detail);
		});

		this.#list.body.on('items:updated',() => {
			if (this.#list.body.model.length > 0) this.classList.add('has-results');
			else this.classList.remove('has-results');
		});
	};

	reqList(cfg)
	{
		return new Promise((resolve, reject) =>
		{
			//init the list
			cfg.fillHeight = true;
			this.buildList(cfg);

			if (this.fetch)
			{
				if (cfg?.filters && cfg?.filters.length > 0)
				{
					//we have filters, wait until they are ready so we can serialize default filter
					//values to pass to the api
					this.filters.on('filter:ready', () =>
					{
						this.trigger('filter:ready');
						this.fetchModel().then(() => resolve(this.list.model));
					});

					this.filters.on('filter:apply',() => this.trigger('filter:apply'));
				}
				else
				{
					this.fetchModel().then(() => resolve(this.#list.model));
				}

			}
			else
			{
				resolve(this.list.model);
			}
		});
	};

	buildList(cfg)
	{
		this.list = new WDList(cfg);

		if (cfg?.filters && cfg.filters.length > 0)
		{
			this.#list.filters = this.addFilters({ filters: cfg.filters, persistKey:cfg?.filterPersistKey });
		}

		return this.#list;
	};

	cleanupCallback() {
		// Clean up the list
		if (this.#list) {
			this.#list.remove();
			this.#list = null;
		}
		
		// Clear config
		this.#config = null;
		
		super.cleanupCallback();
	}

};

customElements.define('wd-pane-list', WDPaneList);
